"use strict";

angular.module("core").directive("localeselector", ["Language", function(Language) {
    return {
        restrict: "E",
        templateUrl: require("./locale-selector.directive.html"),
        link: function(scope) {
            scope.locales = Language.getSupportedLocales();
            Language.initializeScope(scope, null, "locale");
            scope.setLocale = function() {
                Language.set(scope.locale, scope.ignoreUserLanguage);
                if (scope.onChange)
                    scope.onChange();
            };
            scope.click = function(evt) {
                evt.stopPropagation();
            };
        },
        scope: {
            onChange: "=",
            ignoreUserLanguage: "<?"
        }
    };
}]);



//////////////////
// WEBPACK FOOTER
// ./core/locale-selector/locale-selector.directive.js
// module id = 494
// module chunks = 0